<h1>{{'cs.psv.person.idAssignment.header' | hisUi}}</h1>
<p-panel header="{{'cs.psv.person.idAssignment.orcid.header' | hisUi}}" class="columnHalf" [class.autoWidth]="!displaySearchForm">
  <br />
  <h2>{{'cs.psv.person.idAssignment.orcid.search.header' | hisUi}}</h2>
  <div class="layoutBlock">
    <br />
    <psv-person-id-assignment-search-form [lastStartedJob]="lastStartedJob" #searchFormComponent [hidden]="!displaySearchForm" (submitSearch)="submitSearch($event)"></psv-person-id-assignment-search-form>
    @if (!displaySearchForm) {
      <psv-person-id-assignment-search-result [search]="search" (newSearch)="displaySearch(true)" (changeSearch)="displaySearch(false)" (doImport)="doImport($event)"></psv-person-id-assignment-search-result>
    }
  </div>
</p-panel>
